/* eslint-disable */
/* eslint-disable sonarjs/no-identical-functions */
import React, { useEffect, useState } from 'react';
import {
  RACModal,
  RACButton,
  makeStyles,
  TextField,
  RACTextField,
  RACTextbox,
  RACDatePicker,
  RACSelect,
  Typography,
  RACModalCard,
  Grid,
  CircularProgress
} from '@rentacenter/racstrap';
import { ManagePOShipmentInfoRequest, MotorcycleAttributes, PurchaseOrder, UpdatedPOInformation, User } from '../../types/types';
import { ReactComponent as Scanner } from '../../app/assets/img/qr-scanner.svg';
import { BolandSerialPropsType } from './RegularPOList';
import { setUpdatedPOData } from '../../context/global/reducer/selectedPOToReceiveActions';
import { useGlobalContext } from '../../context/global/GlobalContext';
import moment from 'moment';
import { receivePurchaseOrder } from '../../api/purchaseOrders';
import { useTranslation } from 'react-i18next';
import { getSelectedStore } from '../../utils/utils';
import { useStoreDetails } from '../../context/Store/StoreProvider';
import { getCurrentUser, GetRole, GetState } from '../../api/user';
import { useUserStateContext } from '../../context/user/user-contexts';

const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    textAlign: 'left',
    padding: '10px',
  },
  dialogRoot: {
    borderRadius: '12px',
    '& .MuiDialogContent-root': {
      padding: '0',
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: theme.typography.pxToRem(850),
      maxHeight: theme.typography.pxToRem(600),
      borderRadius: '12px',
    },
    '& .MuiTypography-h4': {
      fontSize: '20px !important'
    },
  },
  inputLabel: {
    marginTop: theme.typography.pxToRem(16),
    fontWeight: 600,
    marginBottom: theme.typography.pxToRem(8),
    // marginLeft: theme.typography.pxToRem(24),
    // marginRight: theme.typography.pxToRem(24),

  },
  inputLabel1: {
    marginTop: theme.typography.pxToRem(16),
    fontWeight: 600,
    marginBottom: theme.typography.pxToRem(8),
    marginLeft: theme.typography.pxToRem(24),
  },
  textField1: {
    flexGrow: 1,
    marginRight: theme.typography.pxToRem(8),
    marginLeft: theme.typography.pxToRem(39),
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 900,
    marginTop: theme.typography.pxToRem(20),
    marginBottom: theme.typography.pxToRem(10),
    marginLeft: theme.typography.pxToRem(16),
  },
  inlineFields: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.typography.pxToRem(6),
    marginRight:'3%',
    marginLeft: theme.typography.pxToRem(16),
    marginRight:'3%',
  },
  textFieldContainer: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerSerial: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerReceiverName: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
    textFieldContainerReceivingDate: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerCc: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerColour: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerYear: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerChassis: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerEngine: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerRequestId: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerEntryDate: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerREPUVE: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerLicensePlate: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerState: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  textFieldContainerOdometer: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
     marginRight: '33%'
  },
  Loader: {
    display: 'block',
    position: 'fixed',
    zIndex: 1051,
    top: '50%',
    right: '50%',
  },
  masterLoader: {
    position: 'fixed',
    backgroundColor: '#212529',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: 0.6,
    zIndex: 1050,
    textAlign: 'center',
    margin: 0,
  },
  textField: {
    flexGrow: 1,
    marginRight: theme.typography.pxToRem(8),
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  scannerIcon: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    marginRight: theme.typography.pxToRem(24),

  },


  motorcycleDialogContent: {
    textAlign: 'left',
    padding: '10px',
  },
  motorcycleTextFieldContainer: {
    flexBasis: '32%',
    display: 'flex',
    flexDirection: 'column',
  },
  leftAlignment: {
    marginLeft: theme.typography.pxToRem(24),
  },
  rightAlignment: {
    marginRight: theme.typography.pxToRem(24),

  },


'@media (max-width: 800px)': {
    dialogContent: {
      padding: '20px', // Increase padding for tablet
    },
    inlineFields: {
      flexDirection: 'column', // Stack fields vertically
      // alignItems: 'flex-start', // Align items to the start
      // marginLeft: theme.typography.pxToRem(0), // Remove left margin
      marginTop: theme.typography.pxToRem(10), // Adjust top margin
      marginRight:'5%',
      marginLeft:'5%'
    },
    // For receiver name and reciver block in tablet view 
    inlineFieldsRnRd: {
      display: 'flex',
    justifyContent: 'space-between',
    // marginTop: theme.typography.pxToRem(6),
    // marginLeft: theme.typography.pxToRem(16),
    },
    textFieldContainer: {
      flexBasis: '100%', // Full width for text fields
      marginBottom: theme.typography.pxToRem(16), // Space between fields
    },
    textFieldContainerReceiverName: {
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginRight:'52%',
      
    },
      textFieldContainerReceivingDate: {
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginLeft:'52%',
      marginTop:'-13%',
      
    },
    textFieldContainerCc: {
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginRight:'52%',
      
    },
    textFieldContainerColour: {
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginLeft:'52%',
      marginTop:'-13%',
    },
     textFieldContainerYear: {
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginRight:'52%',
    },
     textFieldContainerChassis: {
     // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginLeft:'52%',
      marginTop:'-15%',
    },
    textFieldContainerEngine: {
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginRight:'52%',
    },
    textFieldContainerRequestId: {
     // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginLeft:'52%',
      marginTop:'-12%',
    },
    textFieldContainerEntryDate : {
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginRight:'52%',
    },
    textFieldContainerREPUVE : {
     // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginLeft:'52%',
      marginTop:'-14%',
    },
    textFieldContainerLicensePlate:{
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginRight:'52%',
    },
    textFieldContainerState: {
     // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginLeft:'52%',
      marginTop:'-15%',
      paddingTop:'1%',
    },
    textFieldContainerOdometer:{
      // flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
       marginRight: '52%',
    },
      
    textFieldContainerSerial: {
      flexBasis: '100%', // Full width for text fields
      marginBottom: theme.typography.pxToRem(16), // Space between fields
    },
    sectionTitle: {
      // fontSize: '18px', // Adjust title size for tablet
      // marginLeft: theme.typography.pxToRem(0), // Center title
      // textAlign: 'center', // Center align title

    fontSize: '16px',
    fontWeight: 900,
    marginTop: theme.typography.pxToRem(20),
    marginBottom: theme.typography.pxToRem(10),
    // marginLeft: theme.typography.pxToRem(16),
    marginLeft:'5%'
    },
    scannerIcon: {
      width: '25px', // Adjust icon size for better visibility
      height: '25px',
      right: '5px', // Adjust position of scanner icon
      marginRight: theme.typography.pxToRem(16), // Adjust right margin
    },
    dialogRoot: {
    borderRadius: '12px',
    '& .MuiDialogContent-root': {
      padding: '0',
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: theme.typography.pxToRem(650),
      maxHeight: theme.typography.pxToRem(950),
      borderRadius: '12px',
    },
    '& .MuiTypography-h4': {
      fontSize: '20px !important'
    },
  },
  },

}));


export interface ReceivingInfoModalProps {
  open: boolean;
  onClose: (pureClose: boolean) => void;
  user: User | undefined;
  serialProps?: BolandSerialPropsType | null;
  isReceivingMotoryCycleInfo?: boolean;
  addSerialNumberabdBol: (
    purchaseOrderId: string,
    manufacturerSerialNumber: string | null,
    billOfLading: string | null,
    poReceived: any,
    index: number,
    partialReceivedPOs: UpdatedPOInformation[],
    poType?: string,
    poVehicleId?: any
  ) => UpdatedPOInformation[];
  // motorcycleAttributes: MotorcycleAttributes,
  setPartialReceivedPOs: React.Dispatch<React.SetStateAction<UpdatedPOInformation[]>>,
  partialReceivedPOs: UpdatedPOInformation[]
  // shippedFromStoreNumber:any,
  serialNumbers: { [key: string]: string },
  setSerialNumbers: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
  validatedMotorcycleDetails: { [key: string]: MotorcycleAttributes },
  setValidatedMotorcycleDetails: React.Dispatch<React.SetStateAction<{ [key: string]: MotorcycleAttributes }>>;
}

export interface Option {
  label: string;
  value: string;
}

const ReceivingInfoModal = (props: ReceivingInfoModalProps) => {

  const {
    open,
    onClose,
    user,
    serialProps,
    isReceivingMotoryCycleInfo,
    addSerialNumberabdBol,
    // motorcycleAttributes,
    setPartialReceivedPOs,
    partialReceivedPOs,
    // shippedFromStoreNumber,
    serialNumbers,
    setSerialNumbers,
    validatedMotorcycleDetails,
    setValidatedMotorcycleDetails

  } = props;
  const classes = useStyles();
  const [serial, setSerial] = useState('');
  const [receiverName, setReceiverName] = useState('');
  const [receivingDate, setReceivingDate] = useState('');
  const [serialErrorMessage, setSerialErrorMessage] = useState('');
  const [currentDate, setCurrentDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const { t } = useTranslation()
  const { store } = useStoreDetails();
  const [modalMessage, setModalMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [currentRole, setCurrentRole] = useState('')
  // const [stateOptions, setStateOptions] = useState<any>([{ label: t('Select'), value: '0' }]);
      const stateOptions = [
    { label: t('Select'), value: '0' },
    { label: t('NUEVO LEON'), value: 'NL' }
  ];
  const [errorMessages, setErrorMessages] = useState<Partial<Record<keyof MotorcycleAttributes, string>>>({});
  const isInventoryManager = currentRole.includes('IMMN');
  const storeName: string | any = store?.storeName
  const [motorcycleUpdatedArray, setMotorcycleUpdatedArray] = useState<MotorcycleAttributes[]>([]);
  
  const [motorcycleDetails, setMotorcycleDetails] = useState<MotorcycleAttributes>({
    poVehicleId: undefined,
    serialNumber: '',
    engineDisplacement: '',
    colour: '',
    engineNumber: '',
    customsDeclaration: '',
    entryDate: '',
    odometer: '',
    licensePlate: '',
    state: '',
    repuve: '',
    year: ''
  });

  const { dispatch } = useGlobalContext();

  const selectClasses = {
    formControl: classes.textField,
    inputLabel: '',
    nativeSelect: '',
    option: '',
    paper: '',
  };

  useEffect(() => {
    const GettingRole = async () => {
      const userDetails = await getCurrentUser();
      let employeeId = userDetails?.employeeId
      if (employeeId) {
        const GetMenuPayload = {
          coworkerId: employeeId,
        }
        const GetMenuDetails: any = await GetRole(GetMenuPayload);
        if (GetMenuDetails.status == 200) {
          const GetMenuDetailsResponse = GetMenuDetails.data;
          const currentRoleRes = GetMenuDetailsResponse.coworkerProfile.role;
          setCurrentRole(currentRoleRes);
        }
      }
    }
    GettingRole()

    // setStateOptions(initialStateOptions);
    // const GetStateDD = async () => {
    //   try {
    //     const res1 = await GetState();
    //     const states = res1?.data;

    //     if (states?.length > 0) {
    //       const buildStateDropDown: any[] = [];
    //       states.map((value: any, index: any) => {
    //         if (index === 0) {
    //           buildStateDropDown.push({ label: t('Select'), value: '0' });
    //         }
    //         buildStateDropDown.push({
    //           label: value?.stateProvinceName,
    //           value: value?.stateProvinceId,
    //         });
    //       });

    //       setStateOptions(buildStateDropDown);


    //     }
    //   } catch (error) {
    //     console.error("Error fetching states:", error);
    //   }
    // };

    // GetStateDD();
  }, [])
  useEffect(() => {
    if (open) {
      setReceiverName(`${user?.firstName} ${user?.lastName}`);
      setReceivingDate(new Date().toISOString().split('T')[0]);
      const currentdate = moment().add(1, "days").format("YYYY-MM-DD");
      const maximumdate = moment().add(3, "months").format("YYYY-MM-DD");
      setCurrentDate(currentdate);
      setMaxDate(maximumdate);
      setErrorMessages({});
      setMotorcycleDetails({
        poVehicleId: undefined,
        serialNumber: '',
        engineDisplacement: '',
        colour: '',
        engineNumber: '',
        customsDeclaration: '',
        entryDate: '',
        odometer: '',
        licensePlate: '',
        state: '',
        repuve: '',
        year: ''
      });
      if (serialProps) {
        setSerial(serialNumbers[serialProps?.receivedId] || '');
        const validatedDetails = validatedMotorcycleDetails[serialProps.receivedId];
        if (validatedDetails) {
          setMotorcycleDetails(validatedDetails);
        }
      }
    }

  }, [open, user, serialProps, isReceivingMotoryCycleInfo, serialNumbers]);




  const motorCycleAttributesPrefilling = async (setMotorcycleDetails: any, vehicleDatails: any, value?: any, setValidatedMotorcycleDetails?: any, serialProps?: any) => {
    console.log("vehicleDatailsvehicleDatails", vehicleDatails, value)

    const filterBySerialNumber = vehicleDatails?.filter((obj: any) => obj.serialNumber == value)
    console.log("filterBySerialNumber", filterBySerialNumber)
    if (filterBySerialNumber[0]?.serialNumber?.toUpperCase() == value?.toUpperCase()) {

      const validatedDetails = {
        poVehicleId: Number(filterBySerialNumber[0]?.vehicleId),
        serialNumber: filterBySerialNumber[0]?.serialNumber || '',
        engineDisplacement: filterBySerialNumber[0]?.engineDisplacement || '',
        colour: filterBySerialNumber[0]?.color || '',
        engineNumber: filterBySerialNumber[0]?.engineNumber || '',
        customsDeclaration: filterBySerialNumber[0]?.customsDeclaration || '',
        entryDate: filterBySerialNumber[0]?.entryDate ? filterBySerialNumber[0]?.entryDate.split('T')[0] : null,
        odometer: String(filterBySerialNumber[0]?.odometer) || '',
        licensePlate: filterBySerialNumber[0]?.licensePlate || '',
        state: "NL",
        repuve: filterBySerialNumber[0]?.repuve || '',
        year: filterBySerialNumber[0]?.year || ''
      };

      setMotorcycleDetails(validatedDetails);

      setValidatedMotorcycleDetails((prev: any) => ({
        ...prev,
        [serialProps.receivedId]: validatedDetails,
      }));
    }
    else {
      setMotorcycleDetails({
        poVehicleId: undefined,
        serialNumber: '',
        engineDisplacement: '',
        colour: '',
        engineNumber: '',
        customsDeclaration: '',
        entryDate: '',
        odometer: '',
        licensePlate: '',
        state: '',
        repuve: '',
        year: ''
      });
    }



  }

  const datePickerClasses = {
    input: classes.textField,
    label: classes.inputLabel,
  };

  const handleChange = (field: keyof MotorcycleAttributes, value: string) => {
    if (value.trim() === '') {
      setErrorMessages((prev) => ({
        ...prev,
        [field]: `${t(field)} ${t("is required")}`,
      }));
    } else {
      // Clear error message if valid
      setErrorMessages((prev) => ({
        ...prev,
        [field]: undefined,
      }));
    }

    if (motorcycleDetails[field] !== value) {
      setHasChanges(true);
    }
    setMotorcycleDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  const handleSave = () => {

    setSerialErrorMessage('');
    if (!isReceivingMotoryCycleInfo) {
      onClose(true);
      return;
    }

    if (isReceivingMotoryCycleInfo && serialErrorMessage) {
      return;
    }
    if (isReceivingMotoryCycleInfo && serial !== serialProps?.poReceived?.serialNumber) {
      setSerialErrorMessage('* Invalid Serial #');
      return;
    }

    if (isInventoryManager && isReceivingMotoryCycleInfo && hasChanges) {

      const validationErrors = Object.keys(motorcycleDetails).reduce((acc, field) => {
        const value = motorcycleDetails[field as keyof MotorcycleAttributes];
        if (typeof value === 'string' && value.trim() === '') {
          acc.push(`${t(field)} ${t("is required")}`);
        }
        return acc;
      }, [] as string[]);

      if (validationErrors.length > 0) {
        validationErrors.forEach((error) => {
          const field = error.split(' ')[0];
          setErrorMessages((prev) => ({
            ...prev,
            [field]: error,
          }));
        });
        return;
      }

    }

    const existingVehicleIndex = motorcycleUpdatedArray.findIndex(vehicle =>
      vehicle.poVehicleId === motorcycleDetails.poVehicleId
    );

    if (existingVehicleIndex !== -1) {
      setMotorcycleUpdatedArray(prev => {
        const updatedArray = [...prev];
        updatedArray[existingVehicleIndex] = { ...motorcycleDetails };
        return updatedArray;
      });
    } else {
      setMotorcycleUpdatedArray(prev => [...prev, motorcycleDetails]);
    }

    onClose(true);

    const storeNumber = getSelectedStore();
    if (isInventoryManager && isReceivingMotoryCycleInfo && hasChanges) {
      setLoader(true);
      const payload: ManagePOShipmentInfoRequest = {
        productDetails: [
          {
            purchaseOrderNumber: serialProps?.purchaseOrderId || '',
            distributionCenter: serialProps?.distributionCenter,
            storeNumber: storeNumber,
            model: serialProps?.poReceived?.modelNumber,
            itemNumber: serialProps?.poReceived?.rmsItemNumber,
            shippedQuantity: serialProps?.poReceived?.quantityOrdered,
            storeName: storeName,
            motorcycleAttributes: [
              {
                ...motorcycleDetails
              }
            ],
          },
        ],
      };


      receivePurchaseOrder(payload).then(() => {
        setLoader(false);
        setModalMessage(t('Motorcycle details updated successfully'));
        setIsModalOpen(true);
      }).catch((err) => {
        setLoader(false);
        setModalMessage(t('Failed to update Motorcycle details'));
        setIsModalOpen(true);
        console.log('Something went wrong', err);
      });
    }

    setSerialErrorMessage('');
  }

  const isTablet = () => {
    return window.innerWidth >= 600 && window.innerWidth <= 1024;
  };


  const openScanner = async () => {
    if (isTablet()) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        const video = document.createElement('video');
        video.srcObject = stream;
        video.play();

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        document.body.appendChild(video);
        document.body.appendChild(canvas);


        const scanFrame = () => {
          context?.drawImage(video, 0, 0, canvas.width, canvas.height);
          requestAnimationFrame(scanFrame);
        };

        scanFrame();
      } catch (error) {
        console.error("Error accessing camera: ", error);
      }
    } else {
      console.log("Scanner is not available on this device.");
    }
  };
  const handleClose = (pureClose: boolean) => {
    setSerial('');
    if (serialProps) {
      setSerialNumbers((prev) => ({
    ...prev,
    [serialProps.receivedId]: '',
  }));

        setValidatedMotorcycleDetails((prev) => {
        const updatedValidated = { ...prev };
        delete updatedValidated[serialProps.receivedId];
        return updatedValidated;
      });
}
    setReceiverName('');
    setReceivingDate('');
    setMotorcycleDetails({
      poVehicleId: undefined,
      serialNumber: '',
      engineDisplacement: '',
      colour: '',
      engineNumber: '',
      customsDeclaration: '',
      entryDate: '',
      odometer: '',
      licensePlate: '',
      state: '',
      repuve: '',
      year: ''
    });
    setSerialErrorMessage('');
    console.log(partialReceivedPOs, "partialReceivedPOs", serialProps, "serialProps")
    const updatedPartialReceivedPOs = partialReceivedPOs.map(po => {
      if (po.purchaseOrderDetailIndex === serialProps?.index) {
        return {
          ...po,
          manufacturerSerialNumber: null
        };
      }
      return po;
    });


    dispatch(setUpdatedPOData(updatedPartialReceivedPOs));



    onClose(pureClose);
  };




  const handleSerialChange = async (value: any, serialProps?: any) => {
setSerialErrorMessage('');
    setSerial(value);
    setSerialNumbers((prev) => ({
      ...prev,
      [serialProps?.receivedId]: value,
    }));

    const updatedPOs = await addSerialNumberabdBol(
      serialProps?.purchaseOrderId || '',
      value,
      null,
      serialProps?.poReceived,
      serialProps?.index !== undefined ? serialProps.index : 0,
      partialReceivedPOs || [],
      "",
      serialProps?.poReceived?.vehicleId
    );

    setPartialReceivedPOs(updatedPOs);
  };


  const renderContent = () => {
    if (isReceivingMotoryCycleInfo) {
      return (
        <div>
          <div className={classes.inlineFields}>
            <div className={classes.textFieldContainerSerial}>
              <Typography className={classes.inputLabel}>
                {t("Serial #")}
              </Typography>
              <div style={{ position: "relative" }}>
                <RACTextField
                  name={`serial-${serialProps?.receivedId}`}
                  value={serial}
                  type="text"
                  inputProps={{ maxLength: 20 }}
                  onBlur={(e: any) => {
                    const inputSerial = e.target.value;
                    if (
                      inputSerial &&
                      serialProps &&
                      serialProps.poReceived?.vehicleDetails
                    ) {
                      const isValidSerial =
                        isReceivingMotoryCycleInfo &&
                        inputSerial === serialProps?.poReceived?.serialNumber;
                      if (!isValidSerial) {
                        setSerialErrorMessage("* Invalid Serial #");
                        return;
                      } else {
                        setSerialErrorMessage("");
                      }
                      motorCycleAttributesPrefilling(
                        setMotorcycleDetails,
                        serialProps.poReceived?.vehicleDetails,
                        inputSerial,
                        setValidatedMotorcycleDetails,
                        serialProps
                      );
                      setSerialErrorMessage("");
                    }
                    dispatch(setUpdatedPOData(partialReceivedPOs || []));
                  }}
                  errorMessage={t(serialErrorMessage)}
                  onChange={(e: any) => handleSerialChange(e, serialProps)}
                />
                 <Scanner className={classes.scannerIcon} onClick={openScanner} />             
              </div>
            </div>
            <div className={classes.textFieldContainerReceiverName}>
              <Typography className={classes.inputLabel}>
                {t("Receiver Name")}
              </Typography>
              <RACTextbox
                value={receiverName}
                OnChange={(e: any) => setReceiverName(e.target.value)}
                className={classes.textField}
                placeHolder={t("Enter Receiver Name")}
                disabled={true}
              />
            </div>
            <div className={classes.textFieldContainerReceivingDate}>
              <RACDatePicker
                value={receivingDate}
                label={t("Receiving Date")}
                errorMessage=""
                name="ReceivingDate"
                inputProps={{
                  min: currentDate,
                  max: maxDate,
                }}
                classes={datePickerClasses}
                onChange={(value) => setReceivingDate(value)}
                disabled={true}
              />
            </div>
          </div>

          {/* Title for Motorcycle Info */}
          <div className={classes.sectionTitle}>{t("Motorcycle Info")}</div>
          <div className={classes.inlineFields}>
            <div className={classes.textFieldContainerCc}>
              <Typography className={classes.inputLabel}>
                {t("Cylinder Capacity")}
              </Typography>
              <RACTextbox
                value={motorcycleDetails.engineDisplacement}
                OnChange={(e) =>
                  handleChange("engineDisplacement", e.target.value)
                }
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter Cylinder Capacity")}
              />
              {errorMessages.engineDisplacement && (
                <span style={{ color: "red" }}>
                  {errorMessages.engineDisplacement}
                </span>
              )}
            </div>
            <div className={classes.textFieldContainerColour}>
              <Typography className={classes.inputLabel}>
                {t("Color")}
              </Typography>
              <RACTextbox
                value={motorcycleDetails.colour}
                OnChange={(e) => handleChange("colour", e.target.value)}
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter Color")}
              />
              {errorMessages.colour && (
                <span style={{ color: "red" }}>{errorMessages.colour}</span>
              )}
            </div>
            <div className={classes.textFieldContainerYear}>
              <label className={classes.inputLabel}>{t("Year")}</label>
              <RACSelect
                classes={selectClasses}
                defaultValue={motorcycleDetails.year}
                onChange={(e) => handleChange("year", e.target.value)}
                isDisabled={!isInventoryManager}
                options={[
                  { value: "", label: t("Select Year") },
                  ...[...Array(new Date().getFullYear() - 1900 + 1)].map((_, index) => ({
                    value: (new Date().getFullYear() - index).toString(),
                    label: (new Date().getFullYear() - index).toString(),
                  })),
                ]}
              />
              {errorMessages.year && (
                <span style={{ color: "red" }}>{errorMessages.year}</span>
              )}
            </div>
          </div>
          <div className={classes.inlineFields}>
            <div className={classes.textFieldContainerChassis}>
              <Typography className={classes.inputLabel}>
                {t("Serial/Chassis #")}
              </Typography>
              <RACTextbox
                value={motorcycleDetails.serialNumber}
                OnChange={(e) => handleChange("serialNumber", e.target.value)}
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter Serial/Chassis #")}
              />
              {errorMessages.serialNumber && (
                <span style={{ color: "red" }}>
                  {errorMessages.serialNumber}
                </span>
              )}
            </div>
            <div className={classes.textFieldContainerEngine}>
              <div className={classes.inputLabel}>{t("Engine #")}</div>
              <RACTextbox
                value={motorcycleDetails.engineNumber}
                OnChange={(e) => handleChange("engineNumber", e.target.value)}
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter Engine #")}
              />
              {errorMessages.engineNumber && (
                <span style={{ color: "red" }}>
                  {errorMessages.engineNumber}
                </span>
              )}
            </div>
            <div className={classes.textFieldContainerRequestId}>
              <div className={classes.inputLabel}>{t("Request ID")}</div>
              <RACTextbox
                value={motorcycleDetails.customsDeclaration}
                OnChange={(e) =>
                  handleChange("customsDeclaration", e.target.value)
                }
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter Request ID")}
              />
              {errorMessages.customsDeclaration && (
                <span style={{ color: "red" }}>
                  {errorMessages.customsDeclaration}
                </span>
              )}
            </div>
          </div>
          <div className={classes.inlineFields}>
            <div className={classes.textFieldContainerEntryDate}>
              <RACDatePicker
                value={
                  motorcycleDetails.entryDate
                    ? motorcycleDetails.entryDate.split("T")[0]
                    : ""
                }
                label={t("Entry Date")}
                errorMessage=""
                name="entryDate"
                inputProps={{
                  min: currentDate,
                  max: maxDate,
                }}
                onChange={(value) => handleChange("entryDate", value)}
                disabled={!isInventoryManager}
                style={{ marginTop: "20px" }}
                className={classes.inputLabel}
              />
              {errorMessages.entryDate && (
                <span style={{ color: "red" }}>{errorMessages.entryDate}</span>
              )}
            </div>
            <div className={classes.textFieldContainerREPUVE}>
              <div className={classes.inputLabel}>
                {t("Public Registry of Vehicle (REPUVE)")}
              </div>
              <RACTextbox
                value={motorcycleDetails.repuve}
                OnChange={(e) => handleChange("repuve", e.target.value)}
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter REPUVE")}
              />
              {errorMessages.repuve && (
                <span style={{ color: "red" }}>{errorMessages.repuve}</span>
              )}
            </div>
            <div className={classes.textFieldContainerLicensePlate}>
              <div className={classes.inputLabel}>{t("License Plate")}</div>
              <RACTextbox
                value={motorcycleDetails.licensePlate}
                OnChange={(e) => handleChange("licensePlate", e.target.value)}
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter License Plate #")}
              />
              {errorMessages.licensePlate && (
                <span style={{ color: "red" }}>
                  {errorMessages.licensePlate}
                </span>
              )}
            </div>
          </div>
          <div className={classes.inlineFields}>
            {/* <div className={classes.textFieldContainerState}> */}
            <div
              className={`${classes.textFieldContainer} ${classes.textFieldContainerState}`}
            >
              <div className={classes.inputLabel}>{t("State")}</div>
              <RACSelect
                defaultValue={
                  motorcycleDetails?.state ? motorcycleDetails.state : "0"
                }
                onChange={(e) => handleChange("state", e.target.value)}
                isDisabled={!isInventoryManager}
                options={stateOptions}
              />
              {errorMessages.state && (
                <span style={{ color: "red" }}>{errorMessages.state}</span>
              )}
            </div>
            <div className={classes.textFieldContainerOdometer}>
              <div className={classes.inputLabel}>{t("Odometer")}</div>
              <RACTextbox
                value={motorcycleDetails.odometer}
                OnChange={(e) => handleChange("odometer", e.target.value)}
                className={classes.textField}
                disabled={!isInventoryManager}
                placeHolder={t("Enter Odometer Count")}
              />
              {errorMessages.odometer && (
                <span style={{ color: "red" }}>{errorMessages.odometer}</span>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className={classes.inputLabel1}>{t("Serial #")}</div>

          <div style={{ position: 'relative', padding: '0px 23px' }} >
            <RACTextField
              name={`serial-${serialProps?.receivedId}`}

              value={serial}
              type="text"
              inputProps={{ maxLength: 20 }}
              onBlur={() => {
                dispatch(setUpdatedPOData(partialReceivedPOs || []))
              }
              }

              onChange={(e: any) => handleSerialChange(e, serialProps)}
            />
            <Scanner className={classes.scannerIcon} onClick={openScanner} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
            <div style={{ marginRight: '16px' }}>
              <div className={classes.inputLabel1}>{t("Receiver Name")}</div>
              <RACTextField
                type="text"
                value={receiverName}
                onChange={(value: string) => setReceiverName(value)}
                style={{ marginLeft: '18px' }}
                disabled={true}
              />
            </div>
            <div>
              <div className={classes.inputLabel}>{t("Receiving Date")}</div>
              <RACTextField
                type="date"
                value={receivingDate}
                onChange={(value: string) => setReceivingDate(value)}
                style={{ marginLeft: '18px' }}
                disabled={true}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      {
        loader && <Grid className={classes.masterLoader}>
          <Grid className={classes.Loader}>
            <CircularProgress />
          </Grid>
        </Grid>
      }
      <RACModalCard
        isOpen={isModalOpen}
        maxWidth="xs"
        closeIcon={true}
        onClose={() => setIsModalOpen(false)}
        borderRadius={'25px !important'}
      >
        <Grid item md={12} className="px-2">
          <Grid item md={12} className="text-center">

            <Typography
              style={{ marginBottom: '35px', fontSize: '18px', marginLeft: '40px' }}
            >
              {modalMessage}
            </Typography>
          </Grid>
        </Grid>
      </RACModalCard>
      {open && (
        <RACModal
          isOpen={open}
          titleVariant="h4"
          classes={{
            dialogContent: classes.dialogContent,
            dialog: classes.dialogRoot,
          }}
          maxWidth={isReceivingMotoryCycleInfo == true ? "sm" : "xs"}
          title={t("Receiving Info")}
          content={renderContent()}
          onClose={() => {
            setSerialErrorMessage('');
            if (isReceivingMotoryCycleInfo) {
              setMotorcycleDetails({
                poVehicleId: undefined,
                serialNumber: '',
                engineDisplacement: '',
                colour: '',
                engineNumber: '',
                customsDeclaration: '',
                entryDate: '',
                odometer: '',
                licensePlate: '',
                state: '',
                repuve: '',
                year: ''
              });
            }
            onClose(false);
          }}
          buttons={
            <>
              <RACButton
                variant="outlined"
                color="secondary"
                onClick={() => handleClose(false)}
              >
                {t("Cancel")}
              </RACButton>
              <RACButton
                variant="contained"
                color="primary"
                onClick={handleSave}
                disabled={!serial}
              >
                {t("Save")}
              </RACButton>
            </>
          }
        />
      )}
    </>
  );
};

export default ReceivingInfoModal;